"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizeWithMinMaxMixin = exports.sizeMixin = exports.maxHeightMixin = exports.maxWidthMixin = exports.minHeightMixin = exports.minWidthMixin = exports.heightMixin = exports.widthMixin = void 0;

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _utils = require("../utils");

var _propTypes = require("../prop-types");

var widthMixinBase = function widthMixinBase(_ref) {
  var width = _ref.width,
      theme = _ref.theme;
  return (0, _utils.cssPropWithFallthroughAndPx)('width', width, theme.selectors.space);
};

var widthMixin = (0, _stencilReactDesc.describe)(widthMixinBase).description('Adds a prop for setting CSS width.');
exports.widthMixin = widthMixin;
widthMixin.propTypes = {
  width: (0, _propTypes.cssValue)().description("Sets the CSS 'width' property for the element.")
};

var heightMixinBase = function heightMixinBase(_ref2) {
  var height = _ref2.height,
      theme = _ref2.theme;
  return (0, _utils.cssPropWithFallthroughAndPx)('height', height, theme.selectors.space);
};

var heightMixin = (0, _stencilReactDesc.describe)(heightMixinBase).description('Adds a prop for setting CSS height.');
exports.heightMixin = heightMixin;
heightMixin.propTypes = {
  height: (0, _propTypes.cssValue)().description("Sets the CSS 'height' property for the element.")
};

var minWidthMixinBase = function minWidthMixinBase(_ref3) {
  var minWidth = _ref3.minWidth,
      theme = _ref3.theme;
  return (0, _utils.cssPropWithFallthroughAndPx)('min-width', minWidth, theme.selectors.space);
};

var minWidthMixin = (0, _stencilReactDesc.describe)(minWidthMixinBase).description('Adds a prop for setting CSS min-width.');
exports.minWidthMixin = minWidthMixin;
minWidthMixin.propTypes = {
  minWidth: (0, _propTypes.cssValue)().description("Sets the CSS 'min-width' property for the element.")
};

var minHeightMixinBase = function minHeightMixinBase(_ref4) {
  var minHeight = _ref4.minHeight,
      theme = _ref4.theme;
  return (0, _utils.cssPropWithFallthroughAndPx)('min-height', minHeight, theme.selectors.space);
};

var minHeightMixin = (0, _stencilReactDesc.describe)(minHeightMixinBase).description('Adds a prop for setting CSS min-height.');
exports.minHeightMixin = minHeightMixin;
minHeightMixin.propTypes = {
  minHeight: (0, _propTypes.cssValue)().description("Sets the CSS 'min-height' property for the element.")
};

var maxWidthMixinBase = function maxWidthMixinBase(_ref5) {
  var maxWidth = _ref5.maxWidth,
      theme = _ref5.theme;
  return (0, _utils.cssPropWithFallthroughAndPx)('max-width', maxWidth, theme.selectors.space);
};

var maxWidthMixin = (0, _stencilReactDesc.describe)(maxWidthMixinBase).description('Adds a prop for setting CSS max-width.');
exports.maxWidthMixin = maxWidthMixin;
maxWidthMixin.propTypes = {
  maxWidth: (0, _propTypes.cssValue)().description("Sets the CSS 'max-width' property for the element")
};

var maxHeightMixinBase = function maxHeightMixinBase(_ref6) {
  var maxHeight = _ref6.maxHeight,
      theme = _ref6.theme;
  return (0, _utils.cssPropWithFallthroughAndPx)('max-height', maxHeight, theme.selectors.space);
};

var maxHeightMixin = (0, _stencilReactDesc.describe)(maxHeightMixinBase).description('Adds a prop for setting CSS max-height.');
exports.maxHeightMixin = maxHeightMixin;
maxHeightMixin.propTypes = {
  maxHeight: (0, _propTypes.cssValue)().description("Sets the CSS 'max-height' property for the element.")
};
var sizeMixin = (0, _utils.combineMixins)(widthMixin, heightMixin);
exports.sizeMixin = sizeMixin;
var sizeWithMinMaxMixin = (0, _utils.combineMixins)(widthMixin, heightMixin, minWidthMixin, minHeightMixin, maxWidthMixin, maxHeightMixin);
exports.sizeWithMinMaxMixin = sizeWithMinMaxMixin;